var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.97991 12.0846H5.4447C5.1647 12.0846 4.95956 11.9606 4.82929 11.7127C4.69887 11.4649 4.71491 11.2262 4.87741 10.9964L10.3372 3.11997C10.4494 2.96289 10.5926 2.85546 10.7668 2.79768C10.9408 2.74004 11.1219 2.7449 11.3099 2.81226C11.498 2.87949 11.6355 2.99455 11.7226 3.15747C11.8097 3.32039 11.842 3.49587 11.8195 3.68393L11.193 8.75122H14.302C14.5989 8.75122 14.8083 8.88428 14.9301 9.15039C15.0519 9.41636 15.0162 9.66421 14.8228 9.89393L8.78595 17.1246C8.66526 17.2677 8.51783 17.3605 8.34366 17.4027C8.1695 17.4448 7.99963 17.4279 7.83408 17.3521C7.66852 17.2762 7.54005 17.1603 7.44866 17.0043C7.35727 16.8484 7.32283 16.6764 7.34533 16.4883L7.97991 12.0846Z",
    fill: "#F9F8FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.ddd3783320789911a25d650ab5309ab0.svg";
export { ForwardRef as ReactComponent };